module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzMiAzMiI+PGRlZnM+PHN0eWxlPi5he2ZpbGw6I2ViNTUwNjt9LmJ7ZmlsbDojZmZmO308L3N0eWxlPjwvZGVmcz48dGl0bGU+cGFnZXRvcDwvdGl0bGU+PGNpcmNsZSBjbGFzcz0iYSIgY3g9IjE2IiBjeT0iMTYiIHI9IjE2Ii8+PHBhdGggY2xhc3M9ImIiIGQ9Ik0xNiwxMy4zMkwyMi40LDIwLDI0LDE4LjM0bC02LjQtNi42OEwxNiwxMGwtMS42LDEuNjhMOCwxOC4zNCw5LjYsMjBaIi8+PC9zdmc+"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/pagetop.svg
// module id = SYE1
// module chunks = 0